import React from "react";
import { IconShape } from "../../../../../../types";
import { useMapEditorActions } from "../../../../contexts/MapEditorContext";
import { CategoryTypesSection } from "../../CategoryTypesSection";
import { ShapeSectionOptions } from "../ShapePanel";

/**
 * Category assignment for icon shapes — the same category manager the
 * zone inspector uses (shared `zoneTypes` registry on the map value).
 * Categorized icons show up in the viewer legend as points of interest
 * with a count, and hovering the legend entry highlights them on the map.
 */
export const IconCategoryPanelControls: React.FC<ShapeSectionOptions> = ({
  shapes
}) => {
  const { updateShape } = useMapEditorActions();
  const iconShapes = shapes.filter(
    (shape): shape is IconShape => shape.type === "icon"
  );

  if (iconShapes.length === 0) return null;

  return (
    <CategoryTypesSection
      selectedCategoryId={iconShapes[0].categoryTypeId}
      onChangeCategory={(id) => {
        iconShapes.forEach((shape) => {
          updateShape(shape.id, { categoryTypeId: id } as Partial<IconShape>);
        });
      }}
      onCategoryDeleted={(id) => {
        iconShapes.forEach((shape) => {
          if (shape.categoryTypeId === id) {
            updateShape(shape.id, {
              categoryTypeId: undefined
            } as Partial<IconShape>);
          }
        });
      }}
      hint="Categorized icons appear in the map legend as points of interest."
      namePlaceholder="Category name (e.g. Restrooms)"
    />
  );
};

IconCategoryPanelControls.displayName = "IconCategoryPanelControls";
